import { Sparkles } from 'lucide-react'

interface EmbeddingsIndicatorProps {
  crossDomainCount?: number
}

export default function EmbeddingsIndicator({ crossDomainCount }: EmbeddingsIndicatorProps) {
  return (
    <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-violet-50 border border-violet-200">
      <Sparkles className="w-3.5 h-3.5 text-violet-500" />
      <span className="text-xs font-medium text-violet-700">
        AI-Enhanced Search Active
      </span>
      {crossDomainCount !== undefined && crossDomainCount > 0 && (
        <>
          <span className="text-violet-300 mx-0.5">|</span>
          <span className="text-xs text-violet-600">
            {crossDomainCount} cross-domain {crossDomainCount === 1 ? 'discovery' : 'discoveries'}
          </span>
        </>
      )}
    </div>
  )
}
